import React from 'react';

import { useCreateNews, useUpdateNews } from '../../data';
import NewsForm from './NewsForm';

export const NewsFormCreate = ({ onSubmit, onClose, onExited, open }) => {
  const [createNews, { isLoading }] = useCreateNews();

  const handleSubmit = async (values = {}) => {
    createNews({ date: new Date(), ...values }).then(onSubmit);
  };

  return (
    <NewsForm
      title={'Add News'}
      loading={isLoading}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={{ type: 1 }}
      onSubmit={handleSubmit}
      isShowPartnerNews={true}
      isCreate
    />
  );
};

export const NewsFormEdit = ({ data, onClose, onSubmit, onExited, open }) => {
  const [updateNews, { isLoading }] = useUpdateNews();

  const handleSubmit = async (values) => {
    updateNews({ ...values }).then(onSubmit);
  };

  return (
    <NewsForm
      title={'Edit News'}
      loading={isLoading}
      onClose={onClose}
      onExited={onExited}
      open={open}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
      isShowPartnerNews={false}
    />
  );
};
